module.exports = __webpack_public_path__ + "img/doc-uploaded-err.3984d6fb.svg";